import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { ArrowCounterclockwise } from 'react-bootstrap-icons';
import { useForm } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { clearForm, useFormContext } from '../state/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ClearButton(_ref) {
  var initialValues = _ref.initialValues,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  var form = useForm();

  var _useFormContext = useFormContext(),
      dispatchForm = _useFormContext.dispatch;

  var clearFormDispatch = function clearFormDispatch() {
    return dispatchForm(clearForm());
  };

  var handleClick = function handleClick() {
    form.reset(initialValues);
    clearFormDispatch();
    onClick();
  };

  return /*#__PURE__*/_jsxs(Button, {
    variant: "light",
    disabled: disabled,
    className: "width-max",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(ArrowCounterclockwise, {
      className: "icon"
    }), /*#__PURE__*/_jsx("span", {
      className: "ml-2 d-inline d-md-none d-lg-inline",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "form.clear"
      })
    })]
  });
}
ClearButton.propTypes = {
  initialValues: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};